import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "../locales/en/common.json";
import esCommon from "../locales/es/common.json";
import enPlans from "../locales/en/plans.json";
import esPlans from "../locales/es/plans.json";
import enUserGuide from "../locales/en/userGuide.json";
import esUserGuide from "../locales/es/userGuide.json";
import enTipToolHelp from "../locales/en/tipToolHelp.json";
import esTipToolHelp from "../locales/es/tipToolHelp.json";

const supportedLanguages = ["en", "es"] as const;

const syncDocumentLanguage = (language: string) => {
  if (typeof document === "undefined") return;

  document.documentElement.lang = language.toLowerCase().startsWith("es")
    ? "es"
    : "en";
};

const getInitialLanguage = () => {
  if (typeof window === "undefined") {
    return "en";
  }

  const storedLanguage = window.localStorage.getItem("mtam.language");
  if (
    storedLanguage &&
    supportedLanguages.includes(
      storedLanguage as (typeof supportedLanguages)[number],
    )
  ) {
    return storedLanguage;
  }

  const browserLanguage =
    navigator.language || navigator.languages?.[0] || "en";
  return browserLanguage.toLowerCase().startsWith("es") ? "es" : "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      plans: enPlans,
      userGuide: enUserGuide,
      tipToolHelp: enTipToolHelp,
    },
    es: {
      common: esCommon,
      plans: esPlans,
      userGuide: esUserGuide,
      tipToolHelp: esTipToolHelp,
    },
  },
  ns: ["common", "plans", "userGuide", "tipToolHelp"],
  defaultNS: "common",
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

syncDocumentLanguage(i18n.language);
i18n.on("languageChanged", syncDocumentLanguage);

export default i18n;
